module.exports = {
	"projects": [
		{
			"filter": "1",
			"background": "bg_afissore",
			"name": "Afissore",
			"job": "system",
			"tags": "system",
			"year": "2015",
			"description": {
				"pt-BR": "Sistema de gerenciamento da ONG",
				"en-US": "System managment"
			},
			"link": ""
		},
		{
			"filter": "1, 2",
			"background": "bg_agere",
			"name": "Ágere Soluções",
			"job": "site_system",
			"tags": "site, system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistema de gerenciamento de atividades e site da Contabilidade",
				"en-US": "System activity management and website third sector accounting"
			},
			"link": "www.agere.com.br"
		},
		{
			"filter": "2",
			"background": "bg_agile",
			"name": "Agile Soluções",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional para divulgação de produtos e serviços",
				"en-US": "Institutional site"
			},
			"link": "www.agilesolucoes.com.br"
		},
		{
			"filter": "4",
			"background": "bg_ainabarcelona",
			"name": "Aina Barcelona",
			"job": "ecommerce",
			"tags": "ecommerce",
			"year": "2016",
			"description": {
				"pt-BR": "Loja virtual situada na Espanha para venda online de joias",
				"en-US": "E-commerce in Spain to sell jewelry"
			},
			"link": "www.ainabarcelona.com"
		},
		{
			"filter": "2",
			"background": "bg_alphavida",
			"name": "Alpha Vida",
			"job": "site",
			"tags": "site",
			"year": "2012",
			"description": {
				"pt-BR": "Site institucional para clínica de tratamento",
				"en-US": "Institutional site"
			},
			"link": "www.alphavida.com.br"
		},
		{
			"filter": "2",
			"background": "bg_amas",
			"name": "Amas",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.amassorocaba.org.br"
		},
		{
			"filter": "2",
			"background": "bg_apaecabreuva",
			"name": "Apae Cabreúva",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": ""
		},
		{
			"filter": "2",
			"background": "bg_bewe",
			"name": "Bëwe",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Desenvolvimento front e back-end para divulgação de portfólio",
				"en-US": "Development front and back end for portfolio site"
			},
			"link": "www.agenciabewe.com.br"
		},
		{
			"filter": "2",
			"background": "bg_buildingstore",
			"name": "Building Store",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional para empresa de diagnóstico estrutural",
				"en-US": "Institutional site"
			},
			"link": "www.buildingstore.com.br"
		},
		{
			"filter": "1, 2",
			"background": "bg_bluecore",
			"name": "Bluecore",
			"job": "site_system",
			"tags": "site, system",
			"year": "2016",
			"description": {
				"pt-BR": "Prestação de serviços internos para clientes diretos da agência",
				"en-US": "Internal services for the agency's direct customers"
			},
			"link": ""
		},
		{
			"filter": "2",
			"background": "bg_catedral",
			"name": "Catedral ",
			"job": "site",
			"tags": "site",
			"year": "2017",
			"description": {
				"pt-BR": "Hotsite",
				"en-US": "Hotsite"
			},
			"link": "www.edificiocathedral.com.br"
		},
		{
			"filter": "1, 3",
			"background": "bg_checkbeer",
			"name": "Checkbeer",
			"job": "App",
			"tags": "system, app",
			"year": "2016",
			"description": {
				"pt-BR": "Aplicativo dedicado aos amantes de cerveja",
				"en-US": "App dedicated to beer lovers"
			},
			"link": "www.checkbeer.com"
		},
		{
			"filter": "2",
			"background": "bg_crmambiental",
			"name": "CRM Ambiental",
			"job": "site",
			"tags": "site",
			"year": "2013",
			"description": {
				"pt-BR": "Site institucional para empresa de Engenharia Ambiental",
				"en-US": "Institutional site"
			},
			"link": "www.crmambiental.com.br"
		},
		{
			"filter": "2",
			"background": "bg_destaque",
			"name": "Destaque Propaganda",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional para divulgação de serviços",
				"en-US": "Institutional site"
			},
			"link": "www.destaquepropaganda.com.br"
		},
		{
			"filter": "2",
			"background": "bg_dpb",
			"name": "DPB",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Desenvolvimentos web para o portal",
				"en-US": "Development web of the portal"
			},
			"link": "www.dpbintercambio.com"
		},
		{
			"filter": "2",
			"background": "bg_enipro",
			"name": "Enipro",
			"job": "site",
			"tags": "site",
			"year": "2013",
			"description": {
				"pt-BR": "Site institucional da Construtora",
				"en-US": "Institutional site"
			},
			"link": "www.enipro.com.br"
		},
		{
			"filter": "2",
			"background": "bg_eprocad",
			"name": "Fundação Eprocad",
			"job": "site",
			"tags": "site",
			"year": "2013",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.eprocad.org.br"
		},
		{
			"filter": "1, 2",
			"background": "bg_fibratex",
			"name": "Fibratex",
			"job": "site_system",
			"tags": "site, system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistema financeiro e site institucional",
				"en-US": "Financial system and corporate website"
			},
			"link": "www.fibratex.com.br"
		},
		{
			"filter": "1, 2",
			"background": "bg_flir",
			"name": "Flir",
			"job": "site_system",
			"tags": "site, system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistema de gestão e sites de conversão",
				"en-US": "Management system and conversion sites"
			},
			"link": ""
		},
		{
			"filter": "2",
			"background": "bg_gerbo",
			"name": "Gerbo Soluções",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional para divulgação de serviços",
				"en-US": "Institutional site"
			},
			"link": ""
		},
		{
			"filter": "2",
			"background": "bg_grandeshistorias",
			"name": "Colégio Uirapuru",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Desenvolvimento front e back-end do portal Grandes Histórias",
				"en-US": "Front and back-end development of the portal Grandes Histórias"
			},
			"link": "grandeshistorias.colegiouirapuru.com.br"
		},
		{
			"filter": "2",
			"background": "bg_hazime",
			"name": "Hazime Enxovais",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional para divulgação de produtos",
				"en-US": "Institutional site"
			},
			"link": "www.hazimeenxovais.com.br"
		},
		{
			"filter": "2",
			"background": "bg_institutovai",
			"name": "Instituto Vai",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.institutovai.com.vc"
		},
		{
			"filter": "2",
			"background": "bg_intacta",
			"name": "Intacta APS",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da empresa",
				"en-US": "Institutional site"
			},
			"link": "www.intactaaps.com.br"
		},
		{
			"filter": "2",
			"background": "bg_intercambio",
			"name": "Intercâmbio de Sucesso",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site para divulgação de cases de intercambistas",
				"en-US": "Campaign hotsite"
			},
			"link": "www.intercambiodesucesso.com"
		},
		{
			"filter": "1, 2",
			"background": "bg_interstage",
			"name": "Intern Stage",
			"job": "Plataforma de estágios",
			"tags": "site, system",
			"year": "2016",
			"description": {
				"pt-BR": "Plataforma para interação de empresa/estagiário",
				"en-US": "Platform for company / intern interaction"
			},
			"link": "www.intstage.com"
		},
		{
			"filter": "2",
			"background": "bg_ipanemaclube",
			"name": "Ipanema Clube",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional do clube",
				"en-US": "Institutional site"
			},
			"link": "www.ipaclube.com.br"
		},
		{
			"filter": "2",
			"background": "bg_isabelexelboemer",
			"name": "Associação Isabel Exel Boemer",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional do ONG",
				"en-US": "Institutional site"
			},
			"link": "www.aieb.org.br"
		},
		{
			"filter": "2",
			"background": "bg_itc",
			"name": "Portal ITC",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site para inscrição de cursos da FLIR",
				"en-US": "Institutional site"
			},
			"link": "www.infraredtraining.com.br"
		},
		{
			"filter": "4",
			"background": "bg_kellerwatches",
			"name": "Keller Watches",
			"job": "ecommerce",
			"tags": "ecommerce",
			"year": "2015",
			"description": {
				"pt-BR": "Loja virtual situada na Irlanda para venda online de relógios",
				"en-US": "E-commerce in Ireland for sale online watches"
			},
			"link": "www.kellerwatches.com"
		},
		{
			"filter": "2",
			"background": "bg_luanova",
			"name": "ONG Lua Nova",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.luanova.org.br"
		},
		{
			"filter": "2",
			"background": "bg_luar",
			"name": "ONG Luar",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.luar.org.br"
		},
		{
			"filter": "2",
			"background": "bg_magicbeans",
			"name": "Magic Beans",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.magicbeans.org.br"
		},
		{
			"filter": "1",
			"background": "bg_mlintercambio",
			"name": "ML Intercâmbios",
			"job": "Landing Page",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Landing Page para captação de leads",
				"en-US": "Landing Page for Lead Capture"
			},
			"link": "www.mundiallanguages.com"
		},
		{
			"filter": "2",
			"background": "bg_momunes",
			"name": "Momunes",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.momunes.org.br"
		},
		{
			"filter": "2",
			"background": "bg_monteirolobato",
			"name": "Lar Escola Monteiro Lobato",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.monteirolobatosorocaba.org"
		},
		{
			"filter": "2",
			"background": "bg_morais",
			"name": "Morais Produtos Naturais",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional para venda online de produtos",
				"en-US": "Institutional site"
			},
			"link": "www.moraisprodutosnaturais.com.br"
		},
		{
			"filter": "2",
			"background": "bg_morumbi",
			"name": "Morumbi Distribuidora",
			"job": "site",
			"tags": "site",
			"year": "2012",
			"description": {
				"pt-BR": "Site institucional da distribuidora",
				"en-US": "Institutional site"
			},
			"link": "www.dmorumbi.com.br"
		},
		{
			"filter": "1",
			"background": "bg_onganize",
			"name": "Onganize",
			"job": "system",
			"tags": "system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistema financeiro para ONGs",
				"en-US": "Financial system for NGOs"
			},
			"link": "www.onganize.com.br"
		},
		{
			"filter": "2",
			"background": "bg_onzegraf",
			"name": "Onzegraf",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional",
				"en-US": "Institutional site"
			},
			"link": "www.onzegraf.com.br"
		},
		{
			"filter": "2",
			"background": "bg_outlabel",
			"name": "Outlabel",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional com solicitação de orçamento",
				"en-US": "Institutional site"
			},
			"link": "www.outlabel.com.br"
		},
		{
			"filter": "2",
			"background": "bg_paroquia",
			"name": "Paróquia São Paulo Apóstolo",
			"job": "site",
			"tags": "site",
			"year": "2013",
			"description": {
				"pt-BR": "Site institucional da Paróquia",
				"en-US": "Institutional site"
			},
			"link": "www.saopauloapostolo.org.br"
		},
		{
			"filter": "2",
			"background": "bg_personalcollege",
			"name": "Personal College",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Plataforma de cursos online",
				"en-US": "Platform online courses"
			},
			"link": "www.personalcollege.com.br"
		},
		{
			"filter": "2",
			"background": "bg_pinturasolidaria",
			"name": "Pintura Solidária",
			"job": "site",
			"tags": "site",
			"year": "2012",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.pinturasolidaria.org.br"
		},
		{
			"filter": "2",
			"background": "bg_pontopravida",
			"name": "Ponto pra Vida",
			"job": "Site/App",
			"tags": "site, app",
			"year": "2016",
			"description": {
				"pt-BR": "Progressive Web App que automatiza a doação de milhas e pontos",
				"en-US": "Progressive Web App that automates the donation of miles and points"
			},
			"link": "www.pontopravida.com.br"
		},
		{
			"filter": "2",
			"background": "bg_proex",
			"name": "ProEx",
			"job": "site",
			"tags": "site",
			"year": "2012",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.proex.org.br"
		},
		{
			"filter": "1",
			"background": "bg_pumpmylead",
			"name": "Pump My Lead",
			"job": "system",
			"tags": "system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistema de gerenciamento de leads",
				"en-US": "Lead management system"
			},
			"link": "www.pumpmylead.com"
		},
		{
			"filter": "2",
			"background": "bg_quilombinho",
			"name": "Quilombinho",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			}
		},
		{
			"filter": "2",
			"background": "bg_santacasapilar",
			"name": "Santa Casa de Pilar do Sul",
			"job": "site",
			"tags": "site",
			"year": "2015",
			"description": {
				"pt-BR": "Site institucional do Hospital",
				"en-US": "Institutional site"
			},
			"link": "www.santacasapilardosul.org.br"
		},
		{
			"filter": "3",
			"background": "bg_sedaapp",
			"name": "Seda APP",
			"job": "app",
			"tags": "app",
			"year": "2016",
			"description": {
				"pt-BR": "Aplicativo da escola",
				"en-US": "App Mobile"
			},
			"link": ""
		},
		{
			"filter": "1",
			"background": "bg_sedacollege",
			"name": "Seda College",
			"job": "system",
			"tags": "system",
			"year": "2016",
			"description": {
				"pt-BR": "Sistemas de gestão da escola",
				"en-US": "School management systems"
			},
			"link": ""
		},
		{
			"filter": "4",
			"background": "bg_smogen",
			"name": "Smogen",
			"job": "Ecommerce",
			"tags": "ecommerce",
			"year": "2016",
			"description": {
				"pt-BR": "Ecommerce internacional de pijamas",
				"en-US": "International Pajamas Ecommerce"
			},
			"link": ""
		},
		{
			"filter": "2",
			"background": "bg_sos",
			"name": "SOS Sorocaba",
			"job": "site",
			"tags": "site",
			"year": "2013",
			"description": {
				"pt-BR": "Site institucional da ONG",
				"en-US": "Institutional site"
			},
			"link": "www.sossorocaba.org.br"
		},
		{
			"filter": "2",
			"background": "bg_tag",
			"name": "Construtora TAG",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional da construtora",
				"en-US": "Institutional site"
			},
			"link": "www.construtoratag.com.br"
		},
		{
			"filter": "2",
			"background": "bg_teacherlaure",
			"name": "Teacher Laura - Escola de Inglês",
			"job": "site",
			"tags": "site",
			"year": "2011",
			"description": {
				"pt-BR": "Site institucional da escola",
				"en-US": "Institutional site"
			},
			"link": "www.teacherlaura.com.br"
		},
		{
			"filter": "1, 2",
			"background": "bg_transparenciasocial",
			"name": "Transparência Social",
			"job": "site_system",
			"tags": "site_system",
			"year": "2016",
			"description": {
				"pt-BR": "Plataforma de serviços para ONGs",
				"en-US": "Service platform for NGOs"
			},
			"link": "www.transparenciasocial.com.br"
		},
		{
			"filter": "2",
			"background": "bg_valentina",
			"name": "Valentina Peroni Arquitetura",
			"job": "site",
			"tags": "site",
			"year": "2014",
			"description": {
				"pt-BR": "Site institucional da Arquiteta e Urbanista Valentina Peroni",
				"en-US": "Institutional site"
			},
			"link": "www.valentinaperoniarquitetura.com.br"
		},
		{
			"filter": "2",
			"background": "bg_wlasan",
			"name": "Faculdade Wlasan",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional da Faculdade",
				"en-US": "Institutional site"
			},
			"link": "www.wlasan.edu.br"
		},
		{
			"filter": "2",
			"background": "bg_zarif",
			"name": "Zarif Seguros",
			"job": "site",
			"tags": "site",
			"year": "2016",
			"description": {
				"pt-BR": "Site institucional da seguradora",
				"en-US": "Institutional site"
			},
			"link": "www.zarifseguros.com.br"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/projects.json
// module id = 64
// module chunks = 0